import { OfferFragment, Ownership_Condition } from '@occc/graphql';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { makeCreatePurchasableEligibilityConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { isFieldWithPathDirty } from '@occc-app/offerHelpers/utils';

import {
  defaultConstraintAwardsFieldName,
  defaultConstraintEnabledFieldName,
  defaultFieldNamePrefix,
} from './award-restrictions.constants';
import { AwardRestrictionsFormValues } from './award-restrictions.types';

export const getAwardRestrictionsOperations = (params: {
  offer: OfferFragment;
  values: AwardRestrictionsFormValues;
  dirtyFields: DirtyFieldsType;
  fieldNamePrefix?: string;
  constraintIsEnabledFieldName?: string;
  constraintAwardsFieldName?: string;
  forceDelete?: boolean;
}): Operation[] => {
  const {
    offer,
    values,
    dirtyFields,
    fieldNamePrefix = defaultFieldNamePrefix,
    constraintIsEnabledFieldName = defaultConstraintEnabledFieldName,
    constraintAwardsFieldName = defaultConstraintAwardsFieldName,
    forceDelete = false,
  } = params;

  const operations: Operation[] = [];
  const existingAwardRestrictions = offer.constraints.find(
    (constraint) => constraint.__typename === 'ConstraintPurchasableEligibility',
  );

  // region Only delete the existing award restrictions if forceDelete is true
  if (forceDelete && existingAwardRestrictions) {
    return [makeDeleteOperation('constraintDelete', existingAwardRestrictions.id)];
  } else if (forceDelete) {
    return [];
  }
  // endregion

  const isDirty =
    isFieldWithPathDirty(dirtyFields, `${fieldNamePrefix}.${constraintIsEnabledFieldName}`) ||
    isFieldWithPathDirty(dirtyFields, `${fieldNamePrefix}.${constraintAwardsFieldName}`);

  if (!isDirty) return operations;

  if (existingAwardRestrictions) {
    operations.push(makeDeleteOperation('constraintDelete', existingAwardRestrictions.id));
  }

  if (values.isEnabled) {
    operations.push(
      makeCreatePurchasableEligibilityConstraintOperation(
        offer.id,
        values.awards.map((award) => award.id),
        Ownership_Condition.OwnsNone,
      ),
    );
  }

  return operations;
};
